const defaultBreakpoints = [576, 768, 992, 1200]

export default defaultBreakpoints
